import { QueryClient } from "@tanstack/react-query";

// eslint-disable-next-line kf/const-naming-convention
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});

// this queryClient is to be used inside common js & store files
// since we can't use useQueryClient hook over there.
export { queryClient };
export { QueryService } from "./../services/query.service.js";
export { ReactQueryDevTools } from "./dev.tools.jsx";
